const PREFIX = '/cms';
const DASHBOARD = PREFIX + '/dashboard';

export const ROUTES_LIST = {
    login: PREFIX + '/login',
    dashboard: DASHBOARD,

    cmsUserEdit: DASHBOARD + '/cms-users/:id',
    cmsUserList: DASHBOARD + '/cms-users',
    cmsUserCreate: DASHBOARD + '/cms-users/create',
    cmsLogList: PREFIX + '/cms-users-log',

    restorePassword: PREFIX + '/restore-password',
    restorePasswordField: PREFIX + '/restore-password-form',

    channelEdit: DASHBOARD + '/channel/:id',
    channelList: DASHBOARD + '/channel',
    channelCreate: DASHBOARD + '/channel/create',

    programTypeEdit: DASHBOARD + '/types/:id',
    programTypeList: DASHBOARD + '/types',
    programTypeCreate: DASHBOARD + '/types/create',

    // ----------------------------
    channelTypeEdit: DASHBOARD + '/channelTypes/:id',
    channelTypeList: DASHBOARD + '/channelTypes',
    channelTypeCreate: DASHBOARD + '/channelTypes/create',
    // -------------------------------
    execute: DASHBOARD + '/execute',
    //   execute
    programList: DASHBOARD + '/program',
    programCreate: DASHBOARD + '/program/create/:channelId',

    programDetailList: DASHBOARD + '/program/:epgProgramId',
    programDetailCreate: DASHBOARD + '/program/:epgProgramId/create',
    programDetailEdit: DASHBOARD + '/program/:epgProgramId/:id',

    programFileList: DASHBOARD + '/file-upload',
    programFileUpload: DASHBOARD + '/file-upload/:epgProgramId',

    foreignChannelList: DASHBOARD + '/foreign-channel',
    epgProcess: DASHBOARD + '/process',

    programArchive: DASHBOARD + '/program-archive',
    programArchiveGraph: DASHBOARD + '/program-archive/graph',

    epgPosters: DASHBOARD + '/posters',
    epgPage: DASHBOARD + '/epg',
    epgPageDetail: DASHBOARD + '/epg/:channelId',

    downloadExample: DASHBOARD + '/example-download',
};
